import React, { useEffect, useState, useRef, useContext } from 'react';
import { BrowserRouter as Router, useLocation, Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import { AnimatePresence, motion } from 'framer-motion';
import "./Navbar.css";
import logo from '../images/mix.JPG'
import { HashLink } from 'react-router-hash-link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faContactCard } from '@fortawesome/free-solid-svg-icons';
import { ScrollContext } from '../components/ScrollContext';

const Navbar = ( {onTabChange} ) => {
    const [curLocation, setCurLocation] = useState("/");
    const [fullCurLocation, setFullCurLocation] = useState("/");
    const location = useLocation();
    const inputRef = useRef(null);
    const [textColor, setTextColor] = useState('black');
    const [backgroundColor, setBackgroundColor] = useState('transparent');
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [english, setEnglish] = useState(false);

    function toggleNavbar() {
        setIsCollapsed(!isCollapsed);
    }

    function collapseHandle() {
        if (!isCollapsed && window.innerWidth < 992) { // Adjust this if your breakpoint is different
            setIsCollapsed(true);
        }
    }

    function changeLanguage() {
        setEnglish(!english);
        //collapseHandle();
        }

    useEffect(() => {
        const fullLocation = location.pathname + location.hash;
        setFullCurLocation(fullLocation);
        setCurLocation(location.pathname);
        onTabChange(location.pathname);

        if (location.pathname === '/gallery') {
            setTextColor('white');
            setBackgroundColor('rgba(20, 20, 20, 1)');
        } else if (location.pathname === '/contact') {
            setTextColor('white');
            setBackgroundColor('rgba(20, 20, 20, 1)');
        } else {
            setTextColor('white');
            setBackgroundColor('rgba(20, 20, 20, 1)');
        }
    }, [location,onTabChange]);

const { activeSection } = useContext(ScrollContext);



    return (
        <motion.div className='navbar-class' style={{ backgroundColor, color: textColor, transition: 'background-color 1s backInOut' , zIndex:10000}}
        initial={{opacity:0, transition: { duration: 0.1, ease: "easeInOut"}}} 
        animate={{opacity:100,x:'0%', transition: { duration: 0.8 , ease: "easeInOut"}}} 
        exit={{opacity:0, x:'50vw', transition: { duration: 0.3, ease: "easeInOut" }}} >
            <motion.nav className="navbar navbar-expand-lg bg-body-tertiary" role="navigation" style={{ zIndex:100}} >
                <motion.div className="container" >
                    <HashLink smooth to="/#home" className="nav-link">
                        <motion.img className="img-fluid logo" src={logo} alt="" 
                        initial={{position:"reelative", x:'0vw',opacity:1,scale:0, transition: { duration: 0.1, ease: "easeInOut"}}} 
                        animate={{position:"relative", x:'0vw',opacity:1, scale:1, transition: { duration: 0.8 ,delay:0.2, ease: "easeInOut"}}} 
                        exit={{opacity:0, x:'50vw', transition: { duration: 0.3, ease: "easeInOut" }}}
                        />
                        
                    </HashLink>
                    {/* <AnimatePresence> */}
                    {/* {
                        // (location.pathname === '/contact')&&
                        <motion.div className='p-2 border-5 selected-navbar-indicator' style={{ backgroundColor, color: textColor, transition: 'background-color 0.5s easeInOut' , zIndex:10000}}
                                                                initial={{opacity:0,scale:0, transition: { duration: 0.1, ease: "backOut"}}} 
                                                                animate={{opacity:100,scale:1, transition: { duration: 1 , ease: "backOut"}}} 
                                                                exit={{opacity:0,scale:0, transition: { duration: 0.4, ease: "backInOut" }}} layout>
                                                            <div className='row'>
                                                                <div className=''>Contact</div>
                                                                <FontAwesomeIcon icon={faContactCard} style={{ color: '#000000', marginTop: '3px' }} className='col'/>
                                                            </div>
                                                            </motion.div>
                    } */}
                    
                    <br />
                    <Button
                        id='collapseButton'
                        ref={inputRef}
                        color='secondary'
                        variant="outlined"
                        className="navbar-toggler"
                        type="button"
                        aria-controls="navbarContent"
                        aria-expanded={!isCollapsed}
                        aria-label="Toggle navigation"
                        onClick={toggleNavbar}
                    >
                        <span className="navbar-toggler-icon"></span>
                    </Button>
                    {/* </AnimatePresence> */}
                    {!isCollapsed&&
                    <motion.div className={`navbar-collapse show`} id="navbarContent"
                        initial={{opacity:0, transition: { duration: 0.1, ease: "easeInOut"}}} 
                        animate={{opacity:100,x:'0%', transition: { duration: 0.8 , ease: "easeInOut"}}} 
                        exit={{opacity:0, x:'50vw', transition: { duration: 0.3, ease: "easeInOut" }}} >
                        <motion.ul className="nav navbar-nav mx-auto" >
                            <motion.li key="home" className={`nav-item me-2 ${curLocation === '/' ? 'chosen' : ''}`}layout>
                                <HashLink smooth to="/#home" className={`nav-link ms-4 me-4 ${curLocation === '/' && activeSection === 'home' ? 'chosenSub' : ''}`} onClick={collapseHandle} style={{ color: textColor }}>{english?"Home":"Αρχική"}</HashLink>
                            </motion.li>
                            <motion.li key="whoAreWe" className={`nav-item me-2 ${curLocation === '/' ? 'chosen' : ''}`}layout>
                                <HashLink smooth to="/#whoAreWe" className={`nav-link ms-4 me-4 ${curLocation === '/' && activeSection === 'whoAreWe' ? 'chosenSub' : ''}`} onClick={collapseHandle} style={{ color: textColor }}>{english?"Who are we?":"Ποιοί είμαστε;"}</HashLink>
                            </motion.li>
                            <motion.li key="whyUs" className={`nav-item me-2 ${curLocation === '/' ? 'chosen' : ''}`}layout>
                                <HashLink smooth to="/#whyUs" className={`nav-link ms-4 me-4 ${curLocation === '/' && activeSection === 'whyUs' ? 'chosenSub' : ''}`} onClick={collapseHandle} style={{ color: textColor}}>{english?"Why us?":"Γιατί εμάς;"}</HashLink>
                            </motion.li>
                            {/* <motion.li key="gallery" className={`nav-item me-2 ${curLocation === '/gallery' ? 'chosen' : ''}`}layout>
                                <HashLink smooth to="/gallery" className={`nav-link ms-4 me-4 ${fullCurLocation === '/gallery' ? 'chosenSub' : ''}`} onClick={collapseHandle} style={{ color: textColor }}>Gallery</HashLink>
                            </motion.li> */}
              
                            <motion.li key="contact" className={`nav-item me-2 ${curLocation === '/contact' ? 'chosen' : ''}`}layout>
                                <HashLink smooth to="/contact" className={`nav-link ms-4 me-4 ${fullCurLocation === '/contact' ? 'chosenSub' : ''}`} onClick={collapseHandle} style={{ color: textColor }}>{english?"Contact":"Επικοινωνία"}</HashLink>
                            </motion.li>
                            <motion.li key="lang" className={`m=auto`}layout>
                                <button className={`nav-link m-auto`} onClick={changeLanguage} style={{ color: textColor, alignSelf:"center", margin:"auto" }}>{english?"Ελληνικά":"English"}</button>
                            </motion.li>
                        </motion.ul>
                    </motion.div>
                    }
                    
                </motion.div>
            </motion.nav>
        </motion.div>
    );
}

export default Navbar;
